class MediaCardModeSwitcher {
  constructor(card) {
    this.card = card;
    this.buttons = card.querySelectorAll('.mode-switch-btn');
    this.init();
  }

  init() {
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.switchMode(button.dataset.mode);
      });
    });
  }

  switchMode(mode) {
    // Update card display mode
    this.card.dataset.displayMode = mode;

    // Update active button
    this.buttons.forEach(btn => {
      if (btn.dataset.mode === mode) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Handle video autoplay
    if (mode === 'video') {
      const video = this.card.querySelector('.media-card__video');
      if (video) {
        video.play().catch(err => {
          console.log('Video autoplay failed:', err);
        });
      }
    }
  }
}

// Video management for media cards
class MediaCardVideoManager {
  constructor() {
    this.initializeVideos();
  }

  initializeVideos() {
    const videos = document.querySelectorAll('.media-card__video');
    videos.forEach(video => {
      const container = video.closest('.media-card__video-container');

      // Handle video loading state
      const handleVideoLoaded = () => {
        if (container) {
          container.classList.add('video-loaded');
        }
      };

      // Listen for video ready events
      if (video.readyState >= 3) {
        // Video is already loaded
        handleVideoLoaded();
      } else {
        // Wait for video to load
        video.addEventListener('canplay', handleVideoLoaded, { once: true });
        video.addEventListener('loadeddata', handleVideoLoaded, { once: true });
      }

      // Ensure video is ready to play
      video.load();

      // Play video when it becomes visible (if in video mode)
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const card = entry.target.closest('.media-card');
          if (entry.isIntersecting && card.dataset.displayMode === 'video') {
            entry.target.play().catch(err => {
              console.log('Video autoplay failed:', err);
            });
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: 0.5 });

      observer.observe(video);
    });
  }
}

// Initialize video manager when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new MediaCardVideoManager();
});

// Initialize mode switchers
document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.media-card');
  cards.forEach(card => {
    if (card.querySelector('.media-card__mode-switcher')) {
      new MediaCardModeSwitcher(card);
    }
  });
});
